import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <main>
      {/* Hero — Full Background */}
      <section className="relative h-[70vh] md:h-[80vh] min-h-[600px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Breathtaking%20panoramic%20view%20of%20Lake%20Thun%20in%20Switzerland%20at%20golden%20hour%2C%20crystal%20clear%20turquoise%20water%20reflecting%20snow-capped%20Swiss%20Alps%20peaks%2C%20charming%20Oberhofen%20village%20nestled%20on%20the%20lakeshore%20with%20traditional%20Swiss%20architecture%2C%20warm%20amber%20sunlight%20casting%20long%20shadows%20across%20green%20meadows%2C%20pristine%20alpine%20landscape%20with%20dramatic%20sky%2C%20ultra%20premium%20Swiss%20tourism%20photography%2C%20serene%20majestic%20atmosphere%2C%20vibrant%20natural%20colors%2C%20bright%20inspiring%20scene&width=1920&height=900&seq=about-hero-lake-thun-2026-v2&orientation=landscape"
            alt="CASA CHERE LIMITED — London, United Kingdom"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-background-50" />
        </div>
        <div className="relative z-10 w-full max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <span className="text-[10px] uppercase tracking-[3px] text-primary-300 font-semibold">
              CASA CHERE LIMITED
            </span>
            <h1 className="text-5xl md:text-7xl font-heading font-bold text-white mt-4 mb-6 tracking-tight">
              About Us
            </h1>
            <p className="text-lg text-white/80 leading-relaxed max-w-2xl">
              A UK-based premium investment firm deploying institutional capital across five diversified sectors. Founded in 2013 and headquartered in London, we combine British governance with global opportunity.
            </p>
          </div>
        </div>
      </section>

      {/* UK Precision. Global Vision. */}
      <section className="relative pt-16 pb-16 md:pt-24 md:pb-24 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
                About the Firm
              </span>
              <h2 className="text-4xl md:text-6xl font-heading font-bold text-foreground-950 mt-4 mb-6 tracking-tight">
                UK Precision.<br />Global Vision.
              </h2>
              <p className="text-lg text-foreground-500 leading-relaxed">
                CASA CHERE LIMITED is a UK-based premium investment firm deploying institutional capital across five diversified sectors. Founded in 2013 and headquartered in London, we combine British governance with global opportunity.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20modern%20Swiss%20corporate%20office%20interior%20with%20warm%20wood%20and%20natural%20light%2C%20panoramic%20view%20of%20Lake%20Thun%20through%20large%20windows%2C%20professional%20meeting%20room%2C%20clean%20minimalist%20Swiss%20design%2C%20premium%20atmosphere%2C%20bright%20and%20airy&width=700&height=500&seq=about-hero-office-2026&orientation=landscape"
                alt="CASA CHERE LIMITED Office — London"
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Story — The Journey */}
      <section className="relative py-20 md:py-28 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
              Our Story
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mt-4 mb-8 tracking-tight">
              From a London Office to Global Markets
            </h2>

            <div className="prose-custom space-y-6 text-foreground-600 text-base leading-relaxed">
              <p>
                It began with a conviction. In 2013, two British financiers — <strong className="text-foreground-900">Melinda Chere Melville Page</strong> and <strong className="text-foreground-900">Isak Bernstein</strong> — saw something that others missed. While global capital chased short-term speculation, they recognized that the most durable wealth is built through disciplined, diversified, long-term investment — anchored in the values that define the United Kingdom itself: precision, stability, and trust.
              </p>
              <p>
                They incorporated CASA CHERE LIMITED as a private limited company under UK law — not in the City of London, but in the quiet district of Fulham, overlooking the River Thames. The choice was deliberate. Distance from the noise of financial capitals meant clarity of thought. The private limited structure meant rigorous governance from day one.
              </p>
              <p>
                The early years were methodical. Page and Bernstein spent them building the scaffolding of what would become a multi-sector investment platform — cultivating relationships with institutional partners across Europe, developing proprietary due diligence frameworks, and assembling a network of sector specialists who shared their philosophy: invest where you have deep conviction, not where consensus points.
              </p>
              <p>
                By 2015, the firm made its first landmark real estate acquisition — a commercial property in London's West End. That investment, still in the portfolio today, set the template: acquire premium assets in gateway cities, enhance value through active management, and hold for the long term. Over the following decade, the portfolio expanded methodically across sectors — renewable energy in 2016, oil and gas infrastructure in 2018, digital assets and blockchain in 2020, and medical equipment in 2023.
              </p>
              <p>
                Today, the firm manages <strong className="text-foreground-900">€2.4 billion in assets across 47 active investments in 18 countries</strong>. But the founding philosophy remains unchanged. Every investment decision still passes through the same rigorous governance framework that Page and Bernstein established on day one. The office still overlooks the River Thames. And the conviction that disciplined capital builds the future — that conviction has only deepened with time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Directors — Experience & Impact */}
      <section className="relative py-20 md:py-28 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
              Leadership
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mt-4 mb-4 tracking-tight">
              The Architects of Our Success
            </h2>
            <p className="text-foreground-500 text-base leading-relaxed mb-12 max-w-2xl">
              Our directors bring decades of cross-sector expertise in finance, governance, and international investment. Their combined experience spans institutional asset management, cross-border structuring, regulatory compliance, and strategic portfolio allocation — the foundation upon which every investment decision rests.
            </p>

            {/* Director 1 — Melinda Chere Melville Page */}
            <div className="bg-white rounded-2xl border border-foreground-100/20 p-8 md:p-10 mb-8">
              <div className="flex flex-col md:flex-row gap-6 md:gap-8">
                <div className="shrink-0">
                  <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl bg-background-100 border border-foreground-100/30 flex items-center justify-center">
                    <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-300">MP</span>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-heading font-bold text-foreground-950">Melinda Chere Melville Page</h3>
                  <p className="text-primary-500 text-xs uppercase tracking-[2px] font-semibold mt-1 mb-4">
                    Director &amp; Authorized Signatory
                  </p>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-3">
                    With over 25 years of experience in international finance and corporate governance, Melinda Chere Melville Page is the strategic architect behind the firm's multi-sector investment philosophy. Her career spans senior leadership roles at major UK financial institutions, where she developed deep expertise in cross-border structuring, institutional asset management, and regulatory frameworks.
                  </p>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-3">
                    As Director, Page sets the firm's long-term vision and chairs the investment committee. Her discipline in risk assessment and her insistence on British-grade governance have been the defining forces behind the firm's consistent performance across market cycles. Under her stewardship, the portfolio has grown from a single London property to €2.4 billion in diversified assets — without a single year of negative returns.
                  </p>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    Page's network across European institutional investors, sovereign wealth funds, and family offices has been instrumental in securing the strategic partnerships that underpin the firm's growth. She is a frequent speaker at investment forums on the topics of multi-asset diversification and governance standards.
                  </p>
                  <a href="mailto:melinda@casachere.com" className="inline-flex items-center gap-1.5 text-primary-500 hover:text-primary-600 text-xs mt-4 transition-colors cursor-pointer">
                    <i className="ri-mail-line" /> melinda@casachere.com
                  </a>
                </div>
              </div>
            </div>

            {/* Director 2 — Isak Bernstein */}
            <div className="bg-white rounded-2xl border border-foreground-100/20 p-8 md:p-10">
              <div className="flex flex-col md:flex-row gap-6 md:gap-8">
                <div className="shrink-0">
                  <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl bg-background-100 border border-foreground-100/30 flex items-center justify-center">
                    <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-300">IB</span>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-heading font-bold text-foreground-950">Isak Bernstein</h3>
                  <p className="text-primary-500 text-xs uppercase tracking-[2px] font-semibold mt-1 mb-4">
                    Chief Executive Officer &amp; Authorized Signatory
                  </p>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-3">
                    Isak Bernstein is the operational backbone of CASA CHERE LIMITED, bringing over 20 years of expertise in corporate structuring, legal compliance, and UK regulatory frameworks. His deep understanding of the private limited governance model ensures that every investment, partnership, and operational decision adheres to the highest standards of transparency and accountability.
                  </p>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-3">
                    From the firm's registered office at 102 Fulham Palace Road in London, Bernstein embodies the firm's commitment to its British roots. He personally oversees all legal and compliance operations, from cross-border investment structuring to regulatory filings with Companies House. His meticulous approach has ensured the firm's flawless compliance record across 13 years of operation in multiple jurisdictions.
                  </p>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    Bernstein's role extends beyond compliance — he is a key member of the investment committee, where his legal acumen and risk assessment capabilities provide essential balance to the portfolio construction process. His presence ensures that the firm's aggressive pursuit of returns never comes at the expense of the governance standards that define British investment excellence.
                  </p>
                  <a href="mailto:isak@casachere.com" className="inline-flex items-center gap-1.5 text-primary-500 hover:text-primary-600 text-xs mt-4 transition-colors cursor-pointer">
                    <i className="ri-mail-line" /> isak@casachere.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission + Values */}
      <section className="relative py-20 md:py-28 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
                Our Mission
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-4 mb-6 tracking-tight">
                Deploying Capital with Discipline and Purpose
              </h2>
              <p className="text-foreground-500 text-base leading-relaxed mb-4">
                We identify, underwrite, and manage investments that generate superior risk-adjusted returns while contributing to economic development and technological progress. Our multi-sector approach provides natural diversification across geographies, asset types, and market cycles.
              </p>
              <p className="text-foreground-500 text-base leading-relaxed mb-6">
                Every investment decision is evaluated through our proprietary due diligence framework — combining quantitative analysis, on-the-ground research, and rigorous governance standards. We invest where we have conviction, not where consensus leads.
              </p>

              <div className="grid grid-cols-2 gap-4">
                {[
                  { label: 'Discipline', desc: 'Research-driven underwriting' },
                  { label: 'Diversification', desc: 'Five uncorrelated sectors' },
                  { label: 'Transparency', desc: 'UK company governance model' },
                  { label: 'Longevity', desc: '13+ years track record' },
                ].map((v) => (
                  <div key={v.label} className="bg-background-50 rounded-xl px-5 py-4 border border-foreground-100/20">
                    <p className="text-sm font-heading font-bold text-foreground-950">{v.label}</p>
                    <p className="text-xs text-foreground-400 mt-0.5">{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Lake%20Thun%20in%20Switzerland%20on%20a%20bright%20summer%20day%2C%20crystal%20clear%20turquoise%20water%2C%20Swiss%20Alps%20mountains%20in%20background%2C%20charming%20Oberhofen%20village%20on%20lakeshore%2C%20professional%20landscape%20photography%2C%20vibrant%20natural%20colors%2C%20serene%20premium%20atmosphere&width=700&height=560&seq=about-lake-thun-003&orientation=landscape"
                alt="CASA CHERE LIMITED — London, United Kingdom"
                className="w-full h-auto rounded-2xl object-cover"
              />
              <div className="absolute -bottom-4 -left-4 bg-white rounded-xl px-5 py-4 border border-foreground-100/20 hidden lg:block">
                <p className="text-2xl font-heading font-bold text-foreground-950">2013</p>
                <p className="text-[10px] uppercase tracking-[2px] text-foreground-400">Founded</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="relative py-20 md:py-28 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="text-center mb-14">
            <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
              Our Journey
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mt-4 tracking-tight">
              Key Milestones
            </h2>
          </div>

          <div className="max-w-3xl mx-auto">
            {[
              { year: '2013', title: 'Founded in London', desc: 'Melinda Chere Melville Page and Isak Bernstein incorporate CASA CHERE LIMITED as a private limited company in London, laying the foundation for disciplined, diversified investment.' },
              { year: '2015', title: 'First Real Estate Acquisition', desc: 'Entry into UK commercial real estate with a prime London office property — the template for all future acquisitions: premium assets, active management, long-term hold.' },
              { year: '2016', title: 'Energy Sector Entry', desc: 'First renewable energy investment — utility-scale solar installations in Southern Europe, beginning the diversification beyond real estate.' },
              { year: '2018', title: '€1B AUM Milestone', desc: 'Portfolio diversification into oil & gas infrastructure assets. Assets under management surpass €1 billion for the first time.' },
              { year: '2020', title: 'Crypto & Digital Assets', desc: 'Strategic allocation to blockchain infrastructure and digital asset ventures — early regulated crypto exposure for investors.' },
              { year: '2023', title: 'MedTech Expansion', desc: 'Entry into medical equipment with acquisitions in surgical robotics and AI-powered diagnostic imaging, expanding the portfolio to five sectors.' },
              { year: '2026', title: 'Global Reach', desc: '47 active investments across 18 countries, €2.4B+ AUM, 12.8% average annual return. The founding vision — now a global investment platform.' },
            ].map((m, i) => (
              <div key={m.year} className="relative flex gap-8 pb-10 last:pb-0">
                <div className="flex flex-col items-center">
                  <div className="w-3 h-3 rounded-full bg-primary-500 shrink-0 mt-1.5" />
                  {i < 6 && <div className="w-px flex-1 bg-foreground-100/40 mt-2" />}
                </div>
                <div>
                  <span className="text-xs uppercase tracking-[2px] text-primary-500 font-bold">{m.year}</span>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mt-1">{m.title}</h3>
                  <p className="text-foreground-500 text-sm mt-1.5">{m.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Governance */}
      <section className="relative py-20 md:py-28 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
              Governance
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mt-4 mb-6 tracking-tight">
              UK Institutional Standards
            </h2>
            <p className="text-foreground-500 text-base leading-relaxed mb-8">
              As a UK private limited company, we adhere to the highest standards of corporate governance. Our board of directors provides strategic oversight, while our investment committee ensures rigorous underwriting and portfolio monitoring.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
              {[
                { title: 'Board of Directors', items: ['Melinda Chere Melville Page — Director', 'Isak Bernstein — Chief Executive Officer'] },
                { title: 'Registration', items: ['Company No. 08549152', 'Private limited company', 'London, United Kingdom'] },
                { title: 'Authorized Signatories', items: ['Melinda Chere Melville Page', 'Isak Bernstein'] },
              ].map((col) => (
                <div key={col.title} className="bg-background-50 rounded-xl p-6 border border-foreground-100/20">
                  <h4 className="text-sm font-heading font-bold text-foreground-950 mb-3">{col.title}</h4>
                  <ul className="flex flex-col gap-2">
                    {col.items.map((item) => (
                      <li key={item} className="text-foreground-500 text-sm">{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-16 md:py-20 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 tracking-tight">
            Partner With a Proven Team
          </h2>
          <p className="text-foreground-500 text-base max-w-lg mx-auto mb-8">
            Our directors and investment team are available to discuss your objectives and explore how our institutional platform can serve your portfolio.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm uppercase tracking-[2px] font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Get in Touch
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>
    </main>
  );
}